module.exports = __webpack_public_path__ + "static/media/usa-laoshi1.6495ee3f.jpg";